import React, { useState, useEffect } from "react";
import { Dropdown, Button, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";

export const DropdownMenu = (props) => {
  const {
    text = "Save",
    type = "primary",
    disabled = false,
    loading = false,
    menuProps = {},
    icon = null,
    iconPosition = "end",
    width,
    onOpenChange = () => {},
    customStyle = {},
  } = props;

  const [localLoading, setLocalLoading] = useState(loading);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => setLocalLoading(loading), [loading]);

  const handleOpenChange = (open) => {
    setIsOpen(open);
    onOpenChange(open);
  };

  const style = {
    ...(width ? { width } : {}),
    ...customStyle,
  };

  return (
    <Dropdown
      menu={menuProps}
      disabled={disabled}
      onOpenChange={handleOpenChange}
      trigger={["click"]}
    >
      <Button
        type={type}
        loading={localLoading}
        icon={icon}
        iconPosition={iconPosition}
        style={style}
      >
        <Space>{text}</Space>
        <DownOutlined
          style={{
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease-in-out",
          }}
        />
      </Button>
    </Dropdown>
  );
};
